const PaymentMethodSelector = ({ togglepopup, togglepopupPartSales, paymentDetails }) => {
  return (
    <div className='' style={{ height: "100%", borderRadius: '4px', backgroundColor: '#EBE6FA', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
      <div style={{ display: 'flex', gap: '15px', marginBottom: '7px' }}>
        <div style={{ flex: 1 }}>
          <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Payment Method</p>
        </div>
      </div>
      <div className="mb-2" style={{ display: 'flex', gap: '15px' }}>
        <div style={{ flex: 1 }}>
          <p onClick={() => { togglepopup('Cash') }} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#616A87' }}>
            Cash {paymentDetails?.Cash?.amount > 0 && `(₹${paymentDetails.Cash.amount})`}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p onClick={() => { togglepopup('CreditCard') }} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#9EBC98' }}>
            CreditCard {paymentDetails?.CreditCard?.amount > 0 && `(₹${paymentDetails.CreditCard.amount})`}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p onClick={() => { togglepopup('UPI') }} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#F2BA49' }}>
            UPI {paymentDetails?.UPI?.amount > 0 && `(₹${paymentDetails.UPI.amount})`}
          </p>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '15px' }}>
        <div style={{ flex: 1 }}>
          <p onClick={() => { togglepopup('Cheque') }} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#AB778D' }}>
            Cheque {paymentDetails?.Cheque?.amount > 0 && `(₹${paymentDetails.Cheque.amount})`}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p onClick={() => { togglepopup('OldGold') }} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#724F5E' }}>
            Old Gold {paymentDetails?.OldGold?.amount > 0 && `(₹${paymentDetails.OldGold.amount})`}
          </p>
        </div>
        <div style={{ flex: 1 }}>
          <p onClick={() => { togglepopupPartSales() }} className='m-0 pobtn' style={{ cursor: 'pointer', backgroundColor: '#929FCB' }}>
            Part Sale {paymentDetails?.PartSale?.amount > 0 && `(₹${paymentDetails.PartSale.amount})`}
          </p>
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodSelector